module.exports = __webpack_public_path__ + "static/media/shape-i.40a514dd.svg";